import type {RelayFailure} from './relay-failure'
import type {RelayStatus} from './relay-connection-status'

export interface RelayConnectionStatusChange {
  readonly taskId: string
  readonly sessionId: string
  readonly environmentId: string
  readonly status: RelayStatus
  readonly failure?: RelayFailure
  readonly passive: boolean
  readonly passiveKnown: boolean
  /** WebSocket close code observed just before this change, when the socket closed after connecting. */
  readonly closeCode?: number
  /** The live transport is being intentionally replaced to refresh its snapshot. */
  readonly plannedRefresh?: true
}

export interface RelayConnectionObserver {
  statusChanged(change: RelayConnectionStatusChange): void
  disposed(taskId: string): void
}

let observer: RelayConnectionObserver | undefined

/** Lets browser telemetry observe connection status without the relay depending on it. */
export function setRelayConnectionObserver(next: RelayConnectionObserver | undefined): void {
  observer = next
}

export function reportRelayConnectionStatus(change: RelayConnectionStatusChange): void {
  if (!observer) return
  try {
    observer.statusChanged(change)
  } catch {
    // Telemetry must not affect connection handling.
  }
}

export function reportRelayConnectionDisposed(taskId: string): void {
  try {
    observer?.disposed(taskId)
  } catch {
    // Telemetry must not affect connection handling.
  }
}
